export default [
  {
    path: "dashboard",
    name: "dashboard",
    component: () => import("@/views/adminPanel/pages/dashboard/Dashboard.vue"),
    meta: {
      rule: "editor",
    },
  },
  {
    path: "plans-vue",
    name: "plans-vue",
    component: () => import("@/views/adminPanel/pages/plans/Plans.vue"),
    meta: {
      rule: "editor",
      authRequired: false,
    },
  },
  {
    path: "/getapp",
    name: "getapp-vue",
    component: () => import("@/views/adminPanel/pages/getheapp/GetApp.vue"),
    meta: {
      rule: "editor",
      authRequired: false,
    },
  },
];
